<template>
    <div class="page-setting has-bc biz-new-ledger-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button v-if="isEdit" class="default-button publish" @click="updateData" :disabled="status.isDisable">儲存</button>
                    <button v-else class="default-button publish" @click="saveData" :disabled="status.isDisable">新增</button>
                </div>
            </div>
        </div>
        <toogle-block v-if="isEdit">
            <div class="toogle-title" slot="toogle-title">
                記帳來源
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            記帳來源
                        </div>
                        <div class="biz-table-content">
                            <span v-if="insertData.ledgerTargetType === 'SINGLE'">房源</span>
                            <span v-else-if="insertData.ledgerTargetType === 'GROUP'">群組</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            記帳地址
                        </div>
                        <div class="biz-table-content">
                            {{editLedgerObj.name}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-if="isEdit">
            <div class="toogle-title" slot="toogle-title">
                記帳明細
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            記帳時間
                        </div>
                        <span v-show="error.recordingDate" class="error-with-title">{{error.recordingDate}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="insertData.recordingDate" :class="{'active': insertData.recordingDate != null, error: error.recordingDate}" :placeholder="insertData.recordingDate?getFormatDateTime(insertData.recordingDate):'請選擇日期'" value-type="YYYY-MM-DD" format="YYYY-MM-DD" ></date-picker>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 備註
                        </div>
                        <span v-show="error.ledgerItemName" class="error-with-title">{{error.ledgerItemName}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.ledgerItemName}" type="text" v-model="insertData.ledgerItemName" placeholder="請填寫備註">
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block v-else>
            <div class="toogle-title" slot="toogle-title">
                記帳明細
            </div>
            <div class="toogle-body row-block" slot="toogle-body">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 記帳來源
                        </div>
                        <span v-show="error.rent" class="error-with-title">{{error.rent}}</span>
                    </label>
                    <div class="input-arear h-align">
                        <border-radio v-model="insertData.ledgerTargetType" val="SINGLE" text="房源"></border-radio>
                        <border-radio v-model="insertData.ledgerTargetType" val="GROUP" text="群組"></border-radio>
                    </div>
                </div>
                <div v-if="insertData.ledgerTargetType == 'SINGLE'" class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            房源地址
                        </div>
                        <span v-show="error.ledgerTargetId" class="error-with-title">{{error.ledgerTargetId}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select-house :key="componentKey" refName="house" :selectMsg="seletcMsg.house" class="select-scroll" @getId="getSelectId" :setDefault="!insertData.ledgerTargetId">
                            <div class="select-filter">
                                <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                <input v-model="filter.selectHouse" placeholder="搜尋房源" type="text">
                            </div>
                            <ul>
                                <li ref="houseItem" @click="$root.$emit('house-item', selectHouseName(index)), status.isLandlord = item.hasLandlord"  :data-id="item.cid" :data-name="item.address" :data-landlord="item.hasLandlord" v-for="(item, index) in filterHouse" :key="index">
                                    <span class="name" :data-id="item.cid" :data-name="item.address" :data-landlord="item.hasLandlord">業務：{{item.agentName}}</span>
                                    <span class="address" :data-id="item.cid" :data-name="item.address" :data-landlord="item.hasLandlord">
                                        {{item.address}}
                                    </span>
                                </li>
                            </ul>
                        </rent-select-house>
                    </div>
                </div>
                <div v-else class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            群組名稱
                        </div>
                        <span v-show="error.ledgerTargetId" class="error-with-title">{{error.ledgerTargetId}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select-house :key="componentKey" refName="group" :selectMsg="seletcMsg.house" class="select-scroll" @getId="getSelectId" :setDefault="!insertData.ledgerTargetId">
                            <div class="select-filter">
                                <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                <input v-model="filter.selectGroup" placeholder="搜尋房源" type="text">
                            </div>
                            <ul>
                                <li ref="houseItem" @click="$root.$emit('house-item', selectHouseName(index))"  :data-id="item.houseGroupId" :data-name="item.houseGroupName" :data-landlord="item.landlordName" v-for="(item, index) in filterGroup" :key="index">
                                    <span class="name" :data-id="item.houseGroupId" :data-name="item.houseGroupName" :data-landlord="item.landlordName">業務：{{item.agentName}}</span>
                                    <span class="address" :data-id="item.houseGroupId" :data-name="item.houseGroupName" :data-landlord="item.landlordName">
                                        {{item.houseGroupName}}
                                    </span>
                                </li>
                            </ul>
                        </rent-select-house>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            記帳時間
                        </div>
                        <span v-show="error.recordingDate" class="error-with-title">{{error.recordingDate}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="insertData.recordingDate" :class="{'active': insertData.recordingDate != null, error: error.recordingDate}" :placeholder="insertData.recordingDate?getFormatDateTime(insertData.recordingDate):'請選擇日期'" value-type="YYYY-MM-DD" format="YYYY-MM-DD" ></date-picker>
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span> 備註
                        </div>
                        <span v-show="error.ledgerItemName" class="error-with-title">{{error.ledgerItemName}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.ledgerItemName}" type="text" v-model="insertData.ledgerItemName" placeholder="請填寫備註">
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                記帳金額
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> 記帳類別
                                <word-tips-hover data="若房源有設定房東，記帳此房源的收入或支出類別時，如打勾記帳金額下方的加入屋主對帳單或幫屋主代墊，可另外設定金額，將會在建立屋主報表時，供選取是否列在屋主報表中。" width="300px"></word-tips-hover>
                            </div>
                            <span v-show="error.rent" class="error-with-title">{{error.rent}}</span>
                        </label>
                        <div class="input-arear h-align">
                            <border-radio v-model="insertData.ledgerType" val="INCOME" text="收入"></border-radio>
                            <border-radio v-model="insertData.ledgerType" val="EXPENSE" text="支出"></border-radio>
                        </div>
                    </div>
                </div>
                <div v-if="isEdit" class="row-block">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> {{insertData.ledgerItemType !== 'DEPOSIT'?ledgerItemType(insertData.ledgerItemType):insertData.ledgerType==='EXPENSE'?'退房客押金':ledgerItemType(insertData.ledgerItemType)}}
                            </div>
                            <span v-show="errorInputData[ledgerItemTypeIndex].amount" class="error-with-title">{{errorInputData[ledgerItemTypeIndex].amount}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: errorInputData[ledgerItemTypeIndex].amount}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.amount" placeholder="例如： 6000 " >
                        </div>
                        <div class="input-btm h-align">
                            <checkbox v-if="status.isLandlord" :msg="insertData.ledgerType === 'INCOME'?'加入屋主對帳單':'幫屋主代墊'" v-model="inputData[ledgerItemTypeIndex].forLandlord" :val="true"  :isPropChecked="inputData[ledgerItemTypeIndex].forLandlord"></checkbox>
                            <div class="note-position" v-if="insertData.ledgerType ==='EXPENSE'">
                                <div class="input-note" @mouseenter="tipStatus.amount=true" @mouseleave="tipStatus.amount=false">這是什麼？</div>
                                <border-tips v-if="tipStatus.amount" msg="紀錄此房源的支出項目，作為物管公司內部記帳使用，不會列在屋主報表中。" width="178px"></border-tips>
                            </div>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inputData[ledgerItemTypeIndex].forLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> {{insertData.ledgerType === 'INCOME'?'加入屋主對帳單金額':'請款金額'}}
                            </div>
                            <span v-show="errorInputData[ledgerItemTypeIndex].quote" class="error-with-title">{{errorInputData[ledgerItemTypeIndex].quote}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: errorInputData[ledgerItemTypeIndex].quote}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="insertData.quote" placeholder="例如： 6000 ">
                            <!-- <div class="note">10%服務費</div> -->
                        </div>
                        <div class="input-btm h-align">
                            <div class="note-position" v-if="insertData.ledgerType ==='EXPENSE'">
                                <div class="input-note" @mouseenter="tipStatus.quote=true" @mouseleave="tipStatus.quote=false">這是什麼？</div>
                                <border-tips v-if="tipStatus.quote" msg="將引用此項目及請款金額，在建立屋主報表時，可選取是否列在屋主報表的支出項目中。" width="178px"></border-tips>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="row-block" v-for="(item, index) in inputData" :key="'inputData'+index">
                    <div class="col2-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span> {{item.ledgerItemType !== 'DEPOSIT'?ledgerItemType(item.ledgerItemType):insertData.ledgerType==='EXPENSE'?'退房客押金':ledgerItemType(item.ledgerItemType)}}
                                <word-tips-hover v-if="insertData.ledgerType ==='EXPENSE' && index != 0" data="紀錄此房源的支出項目，作為物管公司內部記帳使用，不會列在屋主報表中。" width="300px"></word-tips-hover>
                            </div>
                            <span v-show="errorInputData[index].amount" class="error-with-title">{{errorInputData[index].amount}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: errorInputData[index].amount}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="inputData[index].amount" placeholder="例如： 6000 " >
                        </div>
                        <div class="input-btm h-align">
                            <checkbox v-if="status.isLandlord" :msg="insertData.ledgerType === 'INCOME'?'加入屋主對帳單':'幫屋主代墊'" v-model="inputData[index].forLandlord" :val="true"  :isPropChecked="inputData[index].forLandlord"></checkbox>
                            <div class="note-position" v-if="insertData.ledgerType ==='EXPENSE' && index === 0">
                                <div class="input-note" @mouseenter="tipStatus.amount=true" @mouseleave="tipStatus.amount=false">這是什麼？</div>
                                <border-tips v-if="tipStatus.amount" msg="紀錄此房源的支出項目，作為物管公司內部記帳使用，不會列在屋主報表中。" width="178px"></border-tips>
                            </div>
                        </div>
                    </div>
                    <div class="col2-input" v-if="inputData[index].forLandlord">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span> {{insertData.ledgerType === 'INCOME'?'加入屋主對帳單金額':'請款金額'}}
                                <word-tips-hover v-if="insertData.ledgerType ==='EXPENSE' && index != 0" data="將引用此項目及請款金額，在建立屋主報表時，可選取是否列在屋主報表的支出項目中。" width="300px"></word-tips-hover>
                            </div>
                            <span v-show="errorInputData[index].quote" class="error-with-title">{{errorInputData[index].quote}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: errorInputData[index].quote}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="inputData[index].quote" placeholder="例如： 6000 ">
                            <!-- <div class="note">10%服務費</div> -->
                        </div>
                        <div class="input-btm h-align">
                            <div class="note-position" v-if="insertData.ledgerType ==='EXPENSE' && index === 0">
                                <div class="input-note" @mouseenter="tipStatus.quote=true" @mouseleave="tipStatus.quote=false">這是什麼？</div>
                                <border-tips v-if="tipStatus.quote" msg="將引用此項目及請款金額，在建立屋主報表時，可選取是否列在屋主報表的支出項目中。" width="178px"></border-tips>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import borderRadio from '@/components/bussiness/widges/input/borderRadio.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import DatePicker from 'vue2-datepicker';
import RentSelectHouse from '@/components/bussiness/widges/tools/RentSelectHouse.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
import {
    getHouseMgtList
    } from "@/apis/company/houseMgt.js";
import {
    insertLedger,
    updateLedger,
    getLedgerItem,
    getLedgerDetail
    } from "@/apis/company/ledger.js";
import {
    getHouseGroupList,
    } from "@/apis/company/houseGroup.js";

import { mapGetters } from 'vuex'
const defaultParams = {
    "ledgerTargetType": null,
    "ledgerTargetId": null,
    "ledgerType": null,
    "ledgerItemName": null,
    "recordingDate": null,
    "ledgerItemList": [],
    "amount": null,
    "quote": null
}
const defaultInputData = [
    {
        "ledgerItemType": "RENT",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "BOOKING_DEPOSIT",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "DEPOSIT",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "REPAIR_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "WATER_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "ELECTRICITY_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "GAS_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "INTERNET_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "TV_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "CLEANING_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "MANAGEMENT_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "PARKING_BILL",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
    {
        "ledgerItemType": "OTHER",
        "amount": null,
        "quote": null,
        "forLandlord": false
    },
]
export default {
    data () {
        return {
            componentKey: 0,
            insertData: JSON.parse(JSON.stringify(defaultParams)),
            inputData: JSON.parse(JSON.stringify(defaultInputData)),
            error: JSON.parse(JSON.stringify(defaultParams)),
            errorInputData:  JSON.parse(JSON.stringify(defaultInputData)),
            ledgerItemTypeIndex: 0,
            editLedgerObj: {},
            list: {
                houseList: [],
                houseGroupList: [],
                ledgerItemIncome: [],
                ledgerItemExpense: [],
                ledgerItemAdvencePayment: [],
            },
            filter: {
                selectHouse: null,
                selectGroup: null,
            },
            tipStatus: {
                amount: false,
                quote: false,
                amountList: []
            },
            seletcMsg: {
                house: '請選擇房源',
                period: '選擇帳單日期',
                isDefault: false
            },
            status:{
                isDisable: false,
                isDefault: false,
                isLandlord: false
            },
        }
    },
    props: {
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    created () {
        if(!this.isEdit){
            this.insertData.ledgerTargetType = 'SINGLE'
            this.insertData.ledgerType = 'INCOME'
        }
        this.getLedgerDetail()
        this.getHouseList()
        this.getHouseGroupList()

    },
    mounted() {
        // if(this.isEdit && this.editLedgerObj == null){
        //     this.$router.push({name: 'ledgerMgt'})
        //     this.$store.dispatch('setAlarmStatus', {status: true,title: '請重新選擇記帳',type: 'error'})
        // }
    },
    watch: {
        insertData: {
            handler: function (val) {
                if(this.isEdit){
                    if(val.ledgerType === 'INCOME'){
                        if(val.quote > val.amount){
                            this.errorInputData[this.ledgerItemTypeIndex].quote = '給屋主金額不得大於記帳金額'
                        }else{
                            this.errorInputData[this.ledgerItemTypeIndex].quote = null
                        }
                    }else{
                        this.errorInputData[this.ledgerItemTypeIndex].quote = null
                    }
                }else{
                    if(val.ledgerType === 'INCOME'){
                        for (let i = 0; i < val.ledgerItemList.length; i++) {
                            const element = val.ledgerItemList[i];
                            if(element.quote > element.amount){
                                this.errorInputData[i].quote = '給屋主金額不得大於記帳金額'
                            }else{
                                this.errorInputData[i].quote = null
                            }
                        }
                    }else{
                        for (let i = 0; i < val.ledgerItemList.length; i++) {
                            this.errorInputData[i].quote = null
                        }
                    }
                }
            },
            deep: true,
        },
        inputData: {
            handler: function (val){
                this.insertData.ledgerItemList = val
                // forlandlord為false移除對帳金額及代墊金額
                for (let i = 0; i < val.length; i++) {
                    const element = val[i];
                    if(!element.forLandlord){
                        if(this.isEdit){
                            if(i === this.ledgerItemTypeIndex){
                                this.insertData.quote = null
                            }
                        }else{
                            this.inputData[i].quote = null
                        }
                    }
                    if(!this.isEdit && this.insertData.ledgerType === 'INCOME'){
                        if(element.quote > element.amount){
                            this.errorInputData[i].quote = '給屋主金額不得大於記帳金額'
                        }else{
                            this.errorInputData[i].quote = null
                        }
                    }
                }
            },
            deep: true
        },
        editLedgerObj: {
            handler: function (val) {
                if(!this.isEdit) return
                console.log('editLedgerObj', val)
                if(val.ledgerType === 'ADVANCE_PAYMENT'){
                    this.insertData.ledgerType = 'EXPENSE'
                    this.inputData[this.ledgerItemTypeIndex].forLandlord = true
                }else if(val.ledgerType === 'EXPENSE'){
                    this.insertData.ledgerType = 'EXPENSE'
                }else{
                    this.insertData.ledgerType = 'INCOME'
                }
                this.getLedgerItemTypeIndex(val.ledgerItemType)
                this.insertData.ledgerId = val.ledgerId
                this.insertData.ledgerTargetType = val.isHouseGroup?'GROUP':'SINGLE'
                this.insertData.ledgerTargetId = val.houseCid?val.houseCid:val.houseGroupId
                this.insertData.ledgerItemName = val.ledgerItemName
                this.insertData.recordingDate = val.recordingDate
                this.insertData.amount = val.amount
                this.insertData.quote = val.quote
                this.insertData.ledgerItemType = val.ledgerItemType
                this.seletcMsg.house = val.name
                if(val.isHouseGroup){
                    this.status.isLandlord = true
                }else{
                    this.status.isLandlord = val.hasLandlord
                }
                if(this.insertData.quote){
                    this.inputData[this.ledgerItemTypeIndex].forLandlord = true
                }
                this.componentKey++
            },
            deep: true,
            immediate: true
        },
        'insertData.ledgerTargetType': {
            handler: function (val) {
                this.insertData.ledgerTargetId = null
                this.seletcMsg.house = '請選擇房源'
                if(val == 'SINGLE'){
                    this.getHouseList()
                }else if(val == 'GROUP'){
                    this.getHouseGroupList()
                }
            },
        },
    },
    methods: {
        getLedgerItemTypeIndex: function (type){
            const list = this.inputData
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.ledgerItemType === type){
                    this.ledgerItemTypeIndex = i
                }

            }
        },
        getSelectId: function (value) {
            console.log(value)
            if( value.ref == 'house' ){
                this.insertData.ledgerTargetId = value.id
                this.seletcMsg.isDefault = true
                if(value.hasLandlord === 'true'){
                    this.status.isLandlord = true
                }else{
                    this.status.isLandlord = false
                }
            }else if ( value.ref == 'group' ){
                this.insertData.ledgerTargetId = value.id
                this.seletcMsg.isDefault = false
                if(value.hasLandlord){
                    this.status.isLandlord = true
                }else{
                    this.status.isLandlord = false
                }
            }

        },
        selectHouseName: function (index) {
            return this.$refs.houseItem[index].children[1].innerText
        },
        checkInput: function () {
            if(!this.insertData.ledgerTargetId){
                if(!this.isEdit){
                    this.error.ledgerTargetId = '請選擇房源地址'
                }
            }else{
                this.error.ledgerTargetId = ''
            }
            if(!this.insertData.recordingDate){
                this.error.recordingDate = '記帳時間'
            }else{
                this.error.recordingDate = ''
            }
            if(!this.isAmount){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '至少輸入一筆金額',type: 'error',closeBtn: true})
                return false
            }

            if(
                !this.error.ledgerTargetType &&
                !this.error.ledgerTargetId &&
                !this.error.ledgerType &&
                !this.error.ledgerItemName &&
                !this.error.recordingDate &&
                !this.isError
            ){
                return true
            }
        },
        saveData() {
            if(!this.checkInput()) return
            const data = this.insertData
            this.status.isDisable = true
            insertLedger(data)
            .then(res => {
                this.status.isDisable = false
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '新增記帳成功',type: 'success',closeBtn: false})
                    this.$router.push({name: 'ledgerMgt'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: true})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error',closeBtn: true})
            })
        },
        updateData() {
            console.log(this.checkInput())
            if(!this.checkInput()) return
            const data = this.insertData
            this.status.isDisable = true
            updateLedger(data)
            .then(res => {
                this.status.isDisable = false
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯記帳成功',type: 'success',closeBtn: false})
                    this.$router.push({name: 'ledgerMgt'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: false})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error',closeBtn: true})
            })
        },
        getHouseList: function () {
            getHouseMgtList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.list.houseList = res.data.result.houseList
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getHouseGroupList: function () {
            getHouseGroupList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.list.houseGroupList = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getLedgetItem: function (data) {
            const params = {
                ledgerType: data
            }
            getLedgerItem(params)
            .then(res => {
                console.log(res)
                if( res.status == 200 ){
                    console.table(res.data)
                    if(data == 'INCOME'){
                        this.list.ledgerItemIncome = res.data
                    }else if(data == 'EXPENSE'){
                        this.list.ledgerItemExpense = res.data
                    }else if(data == 'ADVANCE_PAYMENT'){
                        this.list.ledgerItemAdvencePayment = res.data
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getLedgerDetail: function () {
            const params = {
                ledgerId: this.$route.query.id
            }
            getLedgerDetail(params)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.editLedgerObj = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
    },
    computed: {
        filterHouse: function () {
            return this.list.houseList.filter((item) => {
                if(item.complete){
                    if( this.filter.selectHouse ){
                        if(item.address.includes(this.filter.selectHouse)){
                            return item
                        }
                    }else{
                        return item
                    }
                }

            });
        },
        filterGroup: function () {
            return this.list.houseGroupList.filter((item) => {
                if( this.filter.selectGroup ){
                    if(item.houseGroupName.includes(this.filter.selectGroup)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        isAmount: function () {
            let count = 0
            if(this.isEdit){
                this.insertData.amount?count++:false
            }else{
                this.inputData.forEach((item)=>{
                    if(item.amount){
                        count++
                    }
                })
            }

            return count?true:false
        },
        isError: function () {
            let count = 0
            this.errorInputData.forEach((item)=>{
                if(item.amount || item.quote){
                    count++
                }
            })
            return count?true:false
        },
        ...mapGetters({
            employeeRoleList: 'GET_BIZ_EMPLOYEE_ROLE_LIST',
            organizationGroupList: 'GET_BIZ_ORGANIZATION_GROUP_LIST',
            // editLedgerObj: 'GET_BIZ_EDIT_LEDGER_OBJ'
        })
    },
    components: {
        toogleBlock,
        RentSelect,
        btnLoading,
        titleTips,
        borderRadio,
        Checkbox,
        DatePicker,
        wordTipsHover,
        RentSelectHouse,
        borderTips
    }
}
</script>
<style lang="scss">
    .biz-new-ledger-comp{
        padding-bottom: 300px;
        .page-header{
            .btn-group{
                .loading-wrap{
                    position: relative;
                    width: 100%;
                    .default-button{
                        width: 120px;
                        padding: 14px 0 14px 0;
                    }
                    .btn-loading{
                        left: 5px;
                        top: 6px;
                    }
                }
            }
        }
        .toogle-title{
            position: relative;
        }
        .toggle-block > .toogle-body {
            padding: 0 24px 24px 24px;
            .tips-agent{
                font-size: 20px;
                font-weight: 500;
                .ad-title{
                    margin-bottom: 10px;
                }
                .rent{
                    color: #a19d9c;
                    margin-bottom: 16px;
                    .unit{
                        font-size: 14px;
                    }
                }
                .agent{
                    display: flex;
                    align-items: center;
                    .name{
                        color: #fc7171;
                        margin-left: 8px;
                        margin-right: 12px;
                    }
                    .phone{
                        margin-right: 10px;
                        color: #3a455f;
                    }
                }
            }
            .biz-table .biz-table-row .biz-table-title {
                width: 85px;
            }
        }
        .row-block {
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            // justify-content: space-between;
            >div{
                margin-right: 60px;
                &:nth-child(3){
                    margin-right: 0px;
                }
                &:last-child{
                    margin-right: 0px;
                }
            }
            .border-radio{
                width: 156px;
                margin-right: 12px;
                &__radio{
                    width: 154px;
                }
            }
            .mx-datepicker{
                width: 324px;
                input{
                    height: 44px;
                    border-radius: 4px;
                    border: solid 1px #e0dfde;
                    color: #a8a5a4;
                    padding: 13px 16px;
                    box-shadow: none;
                    margin-bottom: 0px;
                }
                .mx-icon-calendar,
                .mx-icon-clear{
                    right: 14px;
                }
            }
            .mx-datepicker.error{
                input{
                    border: solid 1px #fc7171 !important;
                }
            }
            .mx-datepicker:hover{
                input{
                    border: 1px solid #292625;
                    color: #292625;
                }
                i{
                    color: #292625;
                }
            }
            .mx-datepicker.active{
                input{
                    color: #292625;
                    &::placeholder {
                        color: #292625;
                    }
                    &:-ms-input-placeholder {
                        color: #292625;
                    }

                    &::-ms-input-placeholder {
                        color: #292625;
                    }
                }
                i{
                    color: #292625;
                }
            }
        }
        .col2-input {
            position: relative;
            width: 324px;
            margin-bottom: 24px;
            .checkbox{
                margin-top: 9px;
            }
            .is-created{
                color: #a19d9c;
                width: 111%;
                height: 100%;
                margin-left: -16px;
                margin-right: -16px;
                display: flex;
                align-items: center;
                padding-left: 16px;
            }
            .input-btm{
                height: 32px;
                .note-position{
                    position: absolute;
                    right: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/financialReport/ledgerMgt/newLedgerComp.vue